export const displayContentUiLayeredSchema = {
  type: 'HorizontalLayout',
  className: 'display-content-form',
  elements: [
    {
      type: 'VerticalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/targetType',
          component: 'simpleText',
          label: 'Target Type',
        },
        {
          type: 'HorizontalLayout',
          className: 'grid grid-cols-4 gap-x-10 mb-4',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/title',
              placeholder: 'New Display',
              required: true,
              component: 'textField',
              label: 'Title*',
              isDark: true,
              validationRules: [
                {type: 'required', msg: ` is required`},
                {
                  type: 'noSpecialChar',
                  msg: `Please use alphanumeric values to enter a valid input`,
                  excludeLabel: true,
                },
                {
                  type: 'maxLength',
                  limit: 40,
                  msg: ` must be less than or equal to 40 characters`,
                },
              ],
            },
            {
              type: 'Control',
              scope: '#/properties/pointsEarned',
              component: 'textfield',
              placeholder: 'Enter points',
              label: 'Points Earned *',
              className: 'box-size-width text-sm',
              isDark: true,
              required: true,
              validationRules: [
                {type: 'required', msg: ` is required`},
                {type: 'number', msg: ` must be a number`},
              ],
            },
            {
              type: 'Control',
              scope: '#/properties/parentCategory',
              component: 'textField',
              placeholder: 'Add Parent Category',
              label: 'Parent Category',
              isDark: true,
            },
            {
              type: 'Control',
              scope: '#/properties/childCategory',
              component: 'textField',
              placeholder: 'Add Child Category',
              label: 'Child Category',
              isDark: true,
            },
          ],
        },
        {
          type: 'HorizontalLayout',
          className: 'gap-x-10 display-content-textarea',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/excerpt',
              component: 'textarea',
              placeholder: 'Type here',
              className: 'w-full',
              helperText: 'Helper text placeholder',
              label: 'Excerpt',
              showToolbar: true,
              isDark: true,
            },
            {
              type: 'Control',
              scope: '#/properties/terms',
              component: 'textarea',
              helperText: 'Campaign Conditions',
              placeholder: 'Type here',
              className: 'w-full',
              label: 'Terms',
              showToolbar: true,
              isDark: true,
            },
          ],
        },
      ],
    },
  ],
}

export const displayContentUiMainSchema = {
  type: 'HorizontalLayout',
  className: 'display-content-form',
  elements: [
    {
      type: 'VerticalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/targetType',
          component: 'simpleText',
          label: 'Target Type',
        },
        {
          type: 'HorizontalLayout',
          className: 'grid grid-cols-4 mb-5',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/title',
              placeholder: 'New Display',
              component: 'textField',
              label: 'Title*',
              isDark: true,
              required: true,
              validationRules: [
                {type: 'required', msg: ' is required'},
                {
                  type: 'noSpecialChar',
                  msg: 'Please use alphanumeric values to enter a valid input',
                  excludeLabel: true,
                },
                {type: 'maxLength', limit: 40, msg: ` must be less than or equal to 40 characters`},
              ],
            },
          ],
        },
        {
          type: 'HorizontalLayout',
          className: 'gap-x-10 display-content-textarea',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/excerpt',
              component: 'textarea',
              placeholder: 'Type here',
              className: 'w-full',
              helperText: 'Helper text placeholder',
              label: 'Excerpt*',
              showToolbar: true,
              isDark: true,
              validationRules: [
                {type: 'required', msg: ' is required'},
                {
                  type: 'noSpecialChar',
                  msg: 'Please use alphanumeric values to enter a valid input',
                  excludeLabel: true,
                },
              ],
            },
            {
              type: 'Control',
              scope: '#/properties/terms',
              component: 'textarea',
              placeholder: 'Type here',
              className: 'w-full',
              label: 'Terms*',
              showToolbar: true,
              isDark: true,
              validationRules: [
                {type: 'required', msg: ' is required'},
                {
                  type: 'noSpecialChar',
                  msg: 'Please use alphanumeric values to enter a valid input',
                  excludeLabel: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

export const displayContentUiPreReqSchema = {
  type: 'HorizontalLayout',
  className: 'display-content-form',
  elements: [
    {
      type: 'VerticalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/targetType',
          component: 'simpleText',
          label: 'Target Type',
          options: {
            readonly: true,
          },
        },
        {
          type: 'Control',
          scope: '#/properties/title',
          maxLength: '40',
          placeholder: 'Title',
          component: 'textField',
          label: 'Title*',
          isDark: true,
          required: true,
          validationRules: [
            {type: 'required', msg: ' is required'},
            {type: 'noSpecialChar', msg: 'Please use alphanumeric values to enter a valid input', excludeLabel: true},
            {type: 'maxLength', limit: 40, msg: ` must be less than or equal to 40 characters`},
          ],
        },
        {
          type: 'Control',
          scope: '#/properties/excerpt',
          component: 'textField',
          placeholder: 'Excerpt',
          label: 'Excerpt*',
          isDark: true,
          required: true,
          validationRules: [
            {type: 'required', msg: ' is required'},
            {type: 'noSpecialChar', msg: 'Please use alphanumeric values to enter a valid input', excludeLabel: true},
          ],
        },
        {
          type: 'HorizontalLayout',
          className: 'gap-x-10 display-content-textarea',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/terms',
              component: 'textarea',
              placeholder: 'Type here',
              className: 'w-full',
              label: 'Terms*',
              showToolbar: true,
              isDark: true,
              required: true,
              validationRules: [
                {type: 'required', msg: ' is required'},
                {
                  type: 'noSpecialChar',
                  msg: 'Please use alphanumeric values to enter a valid input',
                  excludeLabel: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

export const displayContentJsonSchema = {
  type: 'object',
  title: 'Display Content',
  properties: {
    targetType: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    parentCategory: {
      type: 'string',
    },
    childCategory: {
      type: 'string',
    },
    excerpt: {
      type: 'string',
    },
    terms: {
      type: 'string',
    },
  },
  required: ['title'],
}
